function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.7143 0H2.14286C0.959375 0 0 0.959375 0 2.14286V17.8571C0 19.0406 0.959375 20 2.14286 20H20.7143C21.8978 20 22.8571 19.0406 22.8571 17.8571V2.14286C22.8571 0.959375 21.8978 0 20.7143 0ZM10 17.1429H2.85714V12.8571H10V17.1429ZM10 10H2.85714V5.71429H10V10ZM20 17.1429H12.8571V12.8571H20V17.1429ZM20 10H12.8571V5.71429H20V10Z",
  fill: "rgb(98 220 254)"
});

var SvgTableViewBlue = function SvgTableViewBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTableViewBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/table_view_blue.570de1b3.svg";
export { ForwardRef as ReactComponent };